import React, { useEffect, useState } from 'react';

export default function UpcomingList({ upcomingEvent }) {
  let newMonthFlag = true;
  let currentMonth = '';

  const showNewMonthFlagCheck = (event) => {
    event.event_month !== currentMonth ? (newMonthFlag = true) : false;

    if (newMonthFlag) {
      newMonthFlag = false;
      currentMonth = event.event_month;
      return <UpcomingItem key={event.id} event={event} addMonth={true} />;
    } else {
      return <UpcomingItem key={event.id} event={event} />;
    }
  };

  return (
    <section className="section">
      <div className="container container--xl">
        <div className="grid grid--std">
          <div className="grid__col-lg-8">
            <div className="section__header">
              <h4 className="section__header-text">Upcoming Events by Month</h4>
            </div>
            <div className="upcoming-events__list">
              {upcomingEvent &&
                upcomingEvent.map((event) => showNewMonthFlagCheck(event))}
            </div>
          </div>
          <div className="grid__col-lg-4"></div>
        </div>
        <div className="line-break__hr"></div>
      </div>
    </section>
  );
}

function UpcomingItem({ event, addMonth }) {
  const [dateObject, setDateObject] = useState({});
  const {
    event_month,
    start_date_abbr,
    end_date_abbr,
    event_name,
    citytown,
    phone_number,
    website,
    event_year,
    start_timestamp
  } = event;

  const formatDates = (startDate, endDate) => {
    const startDateArray = startDate.split(' ');
    const endDateArray = endDate.split(' ');
    const [endMonth, endDateNum] = endDateArray;
    const [startMonth, startDateNum] = startDateArray;
    const today = new Date();

    let dateObject = {};

    if (startDateNum === endDateNum && startMonth === endMonth) {
      // Same Start and End Date
      dateObject = {
        first: startDate,
        second: null
      };
    } else if (endDate === undefined || endDate === '') {
      // No End Date Set
      dateObject = {
        first: `${startDate}`,
        second: null
      };
    } else {
      // Different Start and End Dates
      dateObject = {
        first: `${startDate} -`,
        second: endDate
      };
    }

    if (today.getTime() > start_timestamp && dateObject.second !== null) {
      dateObject.first = 'Today -';
    } else if (today.getTime() > start_timestamp) {
      dateObject.first = 'Today';
    }

    setDateObject(dateObject);
  };

  useEffect(() => {
    formatDates(start_date_abbr, end_date_abbr);
  }, [event]);

  return (
    <div>
      {addMonth && (
        <div className="upcoming-events__month-year">
          {`${event_month} ${event_year}`}
        </div>
      )}
      <div className="upcoming-events__item">
        <div className="upcoming-events__date-box">
          <div className="upcoming-events__dates">
            <p>{dateObject.first}</p>
            <p>{dateObject.second}</p>
          </div>
        </div>
        <div className="upcoming-events__information">
          <h6>{event_name}</h6>
          <div className="upcoming-events__details">
            <span className="upcoming-events__city">{citytown}</span>
            {phone_number.length > 1 && (
              <span className="dot">&nbsp;&#8226;</span>
            )}
            <span>&nbsp;&nbsp;{phone_number}</span>
            <div className="upcoming-events__website">
              <span>
                <a href={website}>{website}</a>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
